import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './globals.css';

// iOS Safari auto-zooms into form controls whose computed font-size is
// < 16px when they receive focus. Tagging the root element lets a
// CSS rule force 16px on inputs only on iOS, leaving every other
// platform untouched.
{
  const ua = window.navigator.userAgent;
  const isIos = /iPad|iPhone|iPod/.test(ua)
    || (ua.includes('Mac') && 'ontouchend' in document);
  if (isIos) document.documentElement.classList.add('is-ios');
}

const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');

const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
